import { ReactNode } from "react";
// QueryProvider: 서버 데이터 요청 및 캐싱 관리 (예: React Query)
import { QueryProvider } from "./QueryProvider";
// ThemeProvider: 다크/라이트 모드, 색상 테마 등 스타일 관련 테마 값 공급
import { ThemeProvider } from "./ThemeProvider";
// GlobalStyleProvider: 전체 앱에 적용되는 글로벌 CSS 및 공통 스타일 관리
import { GlobalStyleProvider } from "../styles/GlobalStyleProvider";
// PreloadProvider: 초기 데이터 프리로드, 앱 시작 시 필요한 리소스 준비
import { PreloadProvider } from "./PreloadProvider";

// Re-export PrivateRoute for other components
// PrivateRoute: 인증이 필요한 라우트 접근 제어 (로그인 여부에 따라 접근 가능/불가 처리)
export { PrivateRoute } from "./PrivateRoute";

interface AppProvidersProps {
  children: ReactNode;
}

// AppProviders: 각 Provider를 계층적으로 감싸 전체 앱에 환경, 상태, 스타일, 인증 기능을 공급
// Note: Zustand는 Provider가 필요 없으므로 StateProvider를 제거했습니다.
export const AppProviders = ({ children }: AppProvidersProps) => {
  return (
    <QueryProvider>
      <PreloadProvider>
        <GlobalStyleProvider>
          <ThemeProvider>{children}</ThemeProvider>
        </GlobalStyleProvider>
      </PreloadProvider>
    </QueryProvider>
  );
};
